import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import OrganizationForm from "./OrganizationForm"
import * as ItemTypes from "../../redux/items/types"
import { connect } from "react-redux"

class UpdateOrganization extends React.Component {

  componentDidMount() {

    const { params, setCurrentOrganizationId, organization, loadOrganizations } = this.props
    setCurrentOrganizationId(params.id)
    if(!organization) {
      loadOrganizations()
    }
  }

  render() {
    const { organization } = this.props
    return (
      <div>
        { organization 
        ? <OrganizationForm organization={ organization } /> 
        : <p>Waiting..</p>
        }
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const organization = DckSelectors.selectItemById(state, ItemTypes.Organization, ownProps.params.id)
  return { organization }
},

mapDispatchToProps = dispatch => ({
  setCurrentOrganizationId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.Organization, id)),
  loadOrganizations: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Organization)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateOrganization)



// WEBPACK FOOTER //
// ./src/components/Organizations/UpdateOrganization.js